module.exports = __webpack_public_path__ + "static/media/change_active.341c9e51.svg";